import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/component/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'edit', sortable: false, align: 'center', divider: false, width: 10},
        // {text: '', value: 'supply_type_full', sortable: false, align: 'center', divider: true, width: 20},
        {text: 'Article', value: 'article', sortable: false, align: 'center', divider: true, width: 50},
        {text: 'Alias', value: 'alias', sortable: false, align: 'left', divider: true},
        {text: 'Type', value: 'article_type', sortable: false, align: 'center', divider: true, width: 100},
        {text: 'Category', value: 'category', sortable: false, align: 'center', divider: true, width: 100},
        {
          text: 'Case/Package or Number of pins',
          value: 'case_package_names',
          sortable: false,
          align: 'left',
          divider: true,
          width: 100
        },
        {text: 'Image', value: 'image', sortable: false, align: 'center', divider: true, width: 60},
        {text: 'DSh', value: 'datasheet', sortable: false, align: 'center', divider: true, width: 20, type: 'link'},
        {text: 'MSD level', value: 'msd_level', sortable: false, align: 'center', divider: true, width: 120},
        {text: 'Supply type', value: 'supply_type', sortable: false, align: 'center', divider: true, width: 320},
        {text: 'Tape kind', value: 'tape_kind', sortable: false, align: 'center', divider: true, width: 200},
        {text: 'Tape width', value: 'tape_width', sortable: false, align: 'center', divider: true, width: 120},
        {text: 'Feed pitch', value: 'feed_pitch', sortable: false, align: 'center', divider: true, width: 120},
        {text: 'Reel size', value: 'reel_size', sortable: false, align: 'center', divider: true, width: 120},
    ],
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['article'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filterGroupSingle: [],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        ComponentPackagingTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}